export default "__VITE_PUBLIC_ASSET__7b46fba2__"